import config from "../config.json";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export interface PermissionPage {
  page: string;
  permissions: Permission[];
}

export interface Permission {
  key: string;
  label: string;
}

export interface PermissionCategory {
  category: string;
  pages: PermissionPage[];
}

export interface PermissionDependency {
  permission: string;
  autoEnabledPermissions: string[];
}

export const fetchPermissionDependencies = async (): Promise<PermissionDependency[]> => {
  const response = await axiosInstance.get("/users/permissions/dependencies");
  return response.data;
};

export const fetchPermissions = async (): Promise<PermissionCategory[]> => {
  const response = await axiosInstance.get("/users/permissions");
  return response.data;
};

export const updateRolesAndPermissions = async (
  permissions: Record<string, string[]>
): Promise<void> => {
  const transformedPermissions: Record<string, string[]> = Object.keys(
    permissions
  ).reduce((acc, key) => {
    acc[key.replace(" ", " ")] = permissions[key];
    return acc;
  }, {} as Record<string, string[]>);

  await axiosInstance.put("/users/roles/permissions", transformedPermissions);
};

export const fetchRolesPermissions = async () => {
  const response = await axiosInstance.get("/users/roles/permissions");
  const rolesPermissions = response.data;

  const roleNames = Object.keys(rolesPermissions);

  return { rolesPermissions, roleNames };
};